module.exports = __webpack_public_path__ + "img/komodaru_dento.0d872307.jpg";